export enum PaymentStatusEnum {
	NEW = 1,
	SALE = 2,
	REISSUE = 3,
	REFUND = 4,
}
